import RoutesPath from './RoutesPath';

const routes = [
  {
    type: 'collapse',
    name: 'My Projects',
    key: 'myprojects',
    noCollapse: true,
    route: RoutesPath.MY_PROJECTS,
    icon: 'list',
    tooltip: 'Click to view existing projects',
    width: '67%'
  },
  {
    type: 'collapse',
    name: 'Deleted Projects',
    key: 'deletedprojects',
    noCollapse: true,
    route: RoutesPath.DELETED_PROJECTS,
    icon: 'trash-can',
    tooltip: 'Click to view deleted projects',
    width: '83%'
  }
];

export default routes;
